import { getGameOrigin } from "./postMessageOrigin";
let gameFrame = null;
export const sendToGame = (event, payload) => {
    if (gameFrame === null) {
        gameFrame = document.getElementById("game");
    }
    if (gameFrame === null || gameFrame.contentWindow === null) {
        return false;
    }
    const targetOrigin = getGameOrigin();
    gameFrame.contentWindow.postMessage({ feimOpEvent: event, payload }, targetOrigin);
    return true;
};
